var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Initiate Refund Application",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1200px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "pb16",
    attrs: {
      "span": 24
    }
  }, [_c('el-descriptions', {
    attrs: {
      "column": 3,
      "size": "medium",
      "border": "",
      "labelStyle": {
        width: '130px'
      }
    }
  }, [_c('el-descriptions-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Transaction No.")]), _vm._v(" " + _vm._s(_vm.detail.applymentNo || "") + " ")]), _c('el-descriptions-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Country")]), _vm._v(" " + _vm._s(_vm.detail.country || "") + " ")]), _c('el-descriptions-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Applicant Name")]), _vm._v(" " + _vm._s(_vm.detail.applicantName || "") + " ")])], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Refund Items",
      "prop": "refundInfoList"
    }
  }, [_c('div', {
    staticClass: "addBtnWrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Item")])], 1), _c('el-table', {
    staticClass: "wdb100 mt6",
    attrs: {
      "data": _vm.dataForm.refundInfoList,
      "size": "medium",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Description",
      "prop": "orderDescription",
      "align": "center"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "Gov Fee",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "orange"
        }, [_vm._v(" " + _vm._s(_vm.currencyAndAmountFormat(_vm.getBillingCurrency(scope.row.bankAccountIds, scope.row.invoiceTemplateId), scope.row.deductionAcraFee)) + " ")])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Handling Fee",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "orange"
        }, [_vm._v(" " + _vm._s(_vm.currencyAndAmountFormat(_vm.getBillingCurrency(scope.row.bankAccountIds, scope.row.invoiceTemplateId), scope.row.deductionHandlingFee)) + " ")])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Invoice Template",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.invoiceTemplate(scope.row.invoiceTemplateId)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Bank Accounts",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.getBankAccountTags(scope.row.bankAccountIds, scope.row.invoiceTemplateId)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Apply Reason",
      "prop": "applyReason",
      "align": "center"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('el-button', {
          staticClass: "minWd0 mr10",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.addOrUpdateHandle(scope.row, scope.$index);
            }
          }
        }, [_vm._v("Edit")]), _c('el-button', {
          staticClass: "minWd0 red",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteHandle(scope.$index);
            }
          }
        }, [_vm._v("Delete")])];
      }
    }])
  })], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attachments",
      "prop": "attachmentUrls"
    }
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.attachmentUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attachmentUrls", $$v);
      },
      expression: "dataForm.attachmentUrls"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Submit")])], 1)], 1), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "orderInfoList": _vm.detail.orderInfoList,
      "refundInfoList": _vm.dataForm.refundInfoList,
      "invoiceTemplateList": _vm.invoiceTemplateList
    },
    on: {
      "refreshDataList": _vm.updateData
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }